import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { GetZone } from "../../../Apis/organizationApi";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { AllSecondaryDeploymentReport } from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import { GetAllClearedHotspotTransaction } from "../../../Apis/TransferStationReport/secondaryCollectionTransactionApi";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
const ViewInnerSCVsCircleReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { data, formatDate,shiftName } = location.state || {};
  const navigate = useNavigate();
  const [scvList, setScvList] = useState(data);
  const [zoneName, setZoneName] = useState("");
  const [filterOriginalData, setFilterOriginalData] = useState(data);
  const OwnerType = localStorage.getItem("ownerType");
  const VehicleType = localStorage.getItem("vehicleTypeId");
  const date = localStorage.getItem("date");
  // const shift = localStorage.getItem("shift");
  useEffect(() => {
    const fetchZoneName = async () => {
      try {
        const zoneData = await GetZone();
        const zoneIdFromLocalStorage = localStorage.getItem("zoneId");
        const zoneNamesDictionary = {};

        // Populate the zoneNamesDictionary with zoneId as keys and zoneName as values
        zoneData.forEach((zone) => {
          zoneNamesDictionary[zone.zoneId] = zone.zoneName;
        });

        // Find the zone name corresponding to the zoneId from localStorage
        const zoneName = zoneNamesDictionary[zoneIdFromLocalStorage];

        // Use zoneName as needed
        setZoneName(zoneName);
      } catch (error) {
        console.error("Error fetching zone name:", error);
      }
    };

    fetchZoneName();
  }, []);

  const modifiedData = data?.map((item) => ({
    ...item,
    circle: item.circleName, // Save value of zoneName to zone column
    NoOfVehiclesAlloted: item.allotedVehicleRCV,
    NoOfVehiclesReported: item.beforeImageUrl,
    afterImage: item.afterImageUrl,
  }));
  //       setZonesData(modifiedData);
  //       // Handle the response data as needed
  //     } catch (error) {
  //       console.error("Error fetching zone wise report:", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   const handleSearch = () => {
  //     fetchData(); // Call fetchData when the search button is clicked
  //   };

  const scvCircleReportColumns = [
    {
      name: "S.No",
      width: "70px",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Circle",
      // width: "150px",
      selector: (row) => row["circleName"],
      cell: (row) => (
        <span
        // onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: <>No of Vehicles<br />Alloted</>,
      // width: "200px",
      selector: (row) => row["allotedVehicleRCV"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["allotedVehicleRCV"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: <>No of Vehicles<br />Reported</>,
      // width: "220px",
      selector: (row) => row["reportedVehicelRCV"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleDeploymentClick(row)}
        >
          {row["reportedVehicelRCV"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: <>No of Vehicles<br />Not Reported</>,
      // width: "250px",
      selector: (row) => row["notReportedRCV"],
      cell: (row) => <span>{row["notReportedRCV"]}</span>,
      sortable: true,
    },
    {
      name: <>No.of GVPs<br />Cleared</>,
      // width: "220px",
      selector: (row) => row["clearedCollectionPoints"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleGvpTransactionClick1(row)}
        >
          {row["clearedCollectionPoints"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "No.of Helpers",
      // width: "200px",
      selector: (row) => row["numberOfHelpers"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        // onClick={() => handleTwoTripClick(row, fromDate, toDate)}
        >
          {row["numberOfHelpers"]}
        </span>
      ),
      sortable: true,
    },
    // {
    //   name: "No of Equipment Alloted",
    //   width: "12%",
    //   selector: (row) => (
    //     <span
    //       style={{ color: "blue" }}
    //       // onClick={() => handleThreeTripClick(row, fromDate, toDate)}
    //     >
    //       {row["allotedVehicleLoadingEquipment"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "No of Equipment Reported",
    //   // width:'13%',
    //   selector: (row) => (
    //     <span
    //       style={{ color: "blue" }}
    //       // onClick={() => handleFourTripClick(row, fromDate, toDate)}
    //     >
    //       {row["reportedVehicleLoadingEquipment"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "No of Not Equipment Reported",
    //   // width:'13%',
    //   selector: (row) => (
    //     <span
    //       style={{ color: "blue" }}
    //       // onClick={() => handleMoreThanFourTripClick(row, fromDate, toDate)}
    //     >
    //       {row["notReportedLoadingEquipment"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
  ];

  const handleDeploymentClick = async (row) => {
    console.log(row)
    // setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      let response;
      // Concatenate start and end times with the date
      const startDate = `${fromDate}T${startTime}`;
      const endDate = `${fromDate}T${endTime}`;
      if (row.zoneId !== "" && row.circleId === "") {
        response = await AllSecondaryDeploymentReport(
          startDate,
          endDate,
          "",
          row.circleId, // Pass empty string for circleId
          ownerType,
          shift,
          VehicleType
        );
      }
      if (row.zoneId !== "" && row.circleId !== "") {
        response = await AllSecondaryDeploymentReport(
          startDate,
          endDate,
          selectZone,
          row.circleId, // Pass empty string for circleId
          ownerType,
          shift,
          VehicleType
        );
      }
      navigate("/view-vehicle-inner-report", { state:{data:response.data,formatDate: fromDate,shiftName:shiftName} });
    } catch (error) {
      console.log(error);
    } finally {
      // setIsOptionsLoading(false);
    }
  };
  const handleGvpTransactionClick1 = async (row) => {
    // setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      // Concatenate start and end times with the date
      const startDate = `${fromDate}T${startTime}`;
      const endDate = `${fromDate}T${endTime}`;

      // Call the API only when the "No of GVPs Cleared" field is clicked
      if (row.zoneId !== "" && row.circleId !== "") {
        // Call the API
        const response = await GetAllClearedHotspotTransaction(
          startDate,
          endDate,
          selectZone,
          row.circleId,
         
          shift,
          ownerType,
          VehicleType

        );
        // Handle the response here (e.g., navigate to a new page with the data)
        navigate("/view-Gvp-clearence-report", { state:{data:response.data,formatDate: fromDate,shiftName:shiftName} });
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setIsOptionsLoading(false);
    }
  };

  const fromDate = localStorage.getItem("date");
  const shift = localStorage.getItem("shiftId");
  const ownerType = localStorage.getItem("ownerTypeId");
  const selectZone = localStorage.getItem("zone");

  const handleBackClick = () => {
    navigate(-1, {
      state: {
        fromDate,
        shift,
        zoneName,
        ownerType,
      },
    });
  };

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Circle Wise Reported SCV's at Circle Report as on ${formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - ${shiftName} (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Circle",
      "No of Vehicles Alloted",
      "No of Vehicles Reported",
      "No of Vehicles Not Reported",
      "No of GVPs Cleared",
      "No of Helpers",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 12) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    data.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.circleName?? "N/A",
        item.allotedVehicleRCV?? "N/A",
        item.reportedVehicelRCV?? "N/A",
        item.notReportedRCV?? "N/A",
        item.clearedCollectionPoints?? "N/A",
        item.numberOfHelpers?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 12) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVsCircleReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  const searchSCVCircleHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalData.filter(item => item?.circleName?.toLowerCase()?.includes(term));
    setScvList(data);
  }


  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                    <div className="row">
                    <div className="col-md-10">
                      <div className="form-group">
                        <input
                          placeholder="Search Circle"
                          type="text"
                          className="form-control bg-white"
                          onInput={searchSCVCircleHandler}
                        />
                      </div>
                    </div>
                    </div>
                    <div className="d-flex">
                      <button
                        className="btn btn-secondary me-2"
                        onClick={handleBackClick}
                      >
                        Back
                      </button>
                      <button className="btn btn-excel"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                    </div>
                  </div>
                  <div className="top-header">
                    <span>Circle Wise Reported SCV's at Circle Report on {formatDate? formattedDate(fromDate):getCurrentISTDate()} - {shiftName} (at {getCurrentDateTime1()})</span>

                  </div>
                  <CustomDataTable
                    data={scvList}
                    columns={scvCircleReportColumns}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default ViewInnerSCVsCircleReport;
